/**
 * @fileOverview this is a temporal file to support hydration rollout in Jira
 * It will be removed once the rollout is complete
 */
import React from 'react';

if (
	typeof window !== 'undefined' &&
	new URLSearchParams(window.location.search).get('alt-flags')?.includes('no-effects')
) {
	// Disable useEffect calls to allow hydration to focus on Structure only
	// eslint-disable-next-line @atlassian/tangerine/import/no-implicit-imports,@typescript-eslint/no-empty-function
	React.useEffect = () => {};
	// eslint-disable-next-line @atlassian/tangerine/import/no-implicit-imports,@typescript-eslint/no-empty-function
	React.useLayoutEffect = () => {};

	// eslint-disable-next-line no-console
	console.warn('⛔️ React.useEffect is disabled ⛔️');
}
